<div class="mve-detail-popup-container p-3" fxLayout="column" fxFlex style="overflow-y: auto">
  @if (loading()) {
    <div fxLayoutAlign="end start">
      <ng-container [ngTemplateOutlet]="closeButtonTemplate" />
    </div>
    <div fxFlex fxLayoutAlign="center center">
      <iot-platform-ui-card-loader />
    </div>
  } @else {
    <div fxLayout="column" fxLayoutGap="12px">
      @switch (concept()) {
        @case ('site') {
          <iot-platform-ui-site-detail-basic-info
            (selectSite)="selectElement.emit({ element: $event, destination: 'site' })"
            [site]="site()"
            displayMode="vertical"
          >
            <ng-container headerAction [ngTemplateOutlet]="closeButtonTemplate" />
          </iot-platform-ui-site-detail-basic-info>
          <iot-platform-ui-site-detail-tags [loaded]="!loading()" [tags]="tags()" />
          <iot-platform-ui-site-detail-contacts [canReadContacts]="canReadContacts()" [contacts]="contacts()" />
          <iot-platform-ui-site-detail-assets
            (selectAsset)="selectElement.emit({ element: $event, destination: 'asset' })"
            [assets]="assetsBySite()"
            [isAssetLoaded]="true"
            [totalAssets]="$safeNavigationMigration(assetsBySite?.()?.length)"
          />
          <iot-platform-ui-site-detail-devices
            (selectDevice)="selectElement.emit({ element: $event, destination: 'device' })"
            [devices]="devicesBySite()"
            [isDeviceLoaded]="true"
            [totalDevices]="$safeNavigationMigration(devicesBySite?.()?.length)"
          />
        }
        @case ('asset') {
          <iot4bos-ui-asset-basic-info (selectAsset)="selectElement.emit({ element: $event, destination: 'asset' })" [asset]="asset()" displayMode="vertical">
            <ng-container headerAction [ngTemplateOutlet]="closeButtonTemplate" />
          </iot4bos-ui-asset-basic-info>
          <iot-platform-ui-site-detail-tags [loaded]="true" [tags]="tags()" />
          <iot-platform-ui-site-details-full-info
            (selectSite)="selectElement.emit({ element: $event, destination: 'site' })"
            [isSiteLoaded]="true"
            [site]="complementarySite()"
          />
          <iot4bos-ui-asset-followed-variables-details [asset]="asset()" />
          @if (asset()?.site?.type === 'mobile_fleet') {
            <iot-platform-maps-map-panel-info-toolbox (loadRoutes)="loadRoutes($event)" [asset]="asset()" />
            <iot-platform-maps-map-panel-info-popup (displaySegments)="displaySegments.emit($event)" style="height: 300px; max-height: 300px" />
          }
        }
        @case ('device') {
          <iot-platform-ui-device-details-basic-info
            (selectDevice)="selectElement.emit({ element: $event, destination: 'device' })"
            [device]="device()"
            displayMode="vertical"
          >
            <ng-container headerAction [ngTemplateOutlet]="closeButtonTemplate"
          /></iot-platform-ui-device-details-basic-info>
          <iot-platform-ui-site-detail-tags [loaded]="!loading()" [tags]="tags()" />
          <iot-platform-ui-site-details-full-info
            (selectSite)="selectElement.emit({ element: $event, destination: 'site' })"
            [isSiteLoaded]="!loading()"
            [site]="complementarySite()"
          />
          <iot-platform-ui-device-details-connectors [device]="device()" fxLayoutGap="10px" style="padding-top: 10px" />
        }
      }
    </div>
  }
</div>

<ng-template #closeButtonTemplate>
  <button (click)="closeSidebar()" mat-icon-button style="width: 26px; height: 26px; min-width: 26px; min-height: 26px; padding: 0px">
    <mat-icon>close</mat-icon>
  </button>
</ng-template>
